@use '../../style/variables' as *;
@use '../../style/mixins' as *;

.customer-card {
  position: fixed;
  top: 0;
  left:0;
  bottom: 0;
  right:0;
  background-color: $white;
  z-index: 10000;
  line-height: 1;
  overflow: auto;
  margin-top: 3.7rem;
  padding-bottom: 3rem;

  .close {
    position: absolute;
    top: .5rem;
    right: 1rem;
  }


  .headline {
    color: $ny-red;
    font-weight: 300;
    font-size: 1.5rem;
    text-transform: uppercase;
    text-align: center;
    margin-top: 4rem;
  }

  .qr-container {
    margin-bottom: 1rem;

    .qr-code {
      box-sizing: border-box;
      width: 100%;

      @include mobile {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        display: block;
      }
    }
  }

  .info {
    font-weight: 300;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .card-number-info {
    font-weight: 600;
    text-align: center;
    padding-top: 2rem;

    @include mobile {
      padding-top: 1rem;
    }
  }

  .logo {
    width: 3rem;
  }

  .icon svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  /* Solid icons get a fill */
  .solid {
    fill: $grey-light;
    stroke: none
  }
}